(function () {
  "use strict";

  function parseSvgPath(path) {
    var length = {
      a: 7, c: 6, h: 1, l: 2, m: 2, q: 4, s: 4, t: 2, v: 1, z: 0
    };
    var segment = /([astvzqmhlc])([^astvzqmhlc]*)/ig;
    var number = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/ig;
    var data = [];

    path.replace(segment, function (_, command, args) {
      var type = command.toLowerCase();
      var numbers = args.match(number);
      var values = numbers ? numbers.map(Number) : [];

      if (type === "m" && values.length > 2) {
        data.push([command].concat(values.splice(0, 2)));
        type = type === "m" ? "l" : "L";
        command = command === "m" ? "l" : "L";
      }

      while (true) {
        if (values.length === length[type]) {
          values.unshift(command);
          data.push(values);
          return;
        }
        if (values.length < length[type]) {
          throw new Error("Malformed path data");
        }
        data.push([command].concat(values.splice(0, length[type])));
      }
    });

    return data;
  }

  var SVG_NS = "http://www.w3.org/2000/svg";
  var measureSvg = null;
  var measurePath = null;

  function ensureMeasurePath() {
    if (measurePath) {
      return measurePath;
    }
    if (typeof document === "undefined") {
      return null;
    }

    var svg = document.createElementNS(SVG_NS, "svg");
    svg.setAttribute("width", "0");
    svg.setAttribute("height", "0");
    svg.setAttribute("aria-hidden", "true");
    svg.style.position = "absolute";
    svg.style.width = "0";
    svg.style.height = "0";
    svg.style.overflow = "hidden";
    svg.style.visibility = "hidden";

    var path = document.createElementNS(SVG_NS, "path");
    svg.appendChild(path);

    var parent = document.body || document.documentElement;
    if (parent) {
      parent.appendChild(svg);
    }

    measureSvg = svg;
    measurePath = path;
    return measurePath;
  }

  function roundValue(value, precision) {
    if (!precision) {
      return value;
    }
    var factor = Math.pow(10, precision);
    return Math.round(value * factor) / factor;
  }

  function getPathLength(pathElement, pathData) {
    try {
      pathElement.setAttribute("d", pathData);
      return pathElement.getTotalLength();
    } catch (error) {
      return 0;
    }
  }

  function getPathStart(pathElement, pathData) {
    try {
      pathElement.setAttribute("d", pathData);
      return pathElement.getPointAtLength(0);
    } catch (error) {
      try {
        var parsed = parseSvgPath(pathData);
        if (parsed && parsed.length && parsed[0].length >= 3) {
          return { x: parsed[0][1] || 0, y: parsed[0][2] || 0 };
        }
      } catch (innerError) {
        return { x: 0, y: 0 };
      }
    }
    return { x: 0, y: 0 };
  }

  function pathToPolyline(pathElement, pathData, samples, precision) {
    var length = getPathLength(pathElement, pathData);
    var points = samples && samples > 1 ? samples : 2;
    var step = length > 0 ? length / (points - 1) : 0;
    var d = "";

    if (!isFinite(length) || length <= 0) {
      var fallback = getPathStart(pathElement, pathData);
      var fx = roundValue(fallback.x, precision);
      var fy = roundValue(fallback.y, precision);
      d = "M" + fx + " " + fy;
      for (var i = 1; i < points; i++) {
        d += " L" + fx + " " + fy;
      }
      return d;
    }

    for (var p = 0; p < points; p++) {
      var point = pathElement.getPointAtLength(step * p);
      var x = roundValue(point.x, precision);
      var y = roundValue(point.y, precision);
      d += (p === 0 ? "M" : " L") + x + " " + y;
    }

    return d;
  }

  function normalizePaths(paths, options) {
    var pathElement = ensureMeasurePath();
    if (!pathElement) {
      return paths;
    }

    var settings = options || {};
    var samples = settings.samples;
    var minSamples = settings.minSamples || 32;
    var sampleStep = settings.sampleStep || 2;
    var precision = settings.precision || 3;

    if (!samples) {
      var maxLength = 0;
      for (var i = 0; i < paths.length; i++) {
        var currentLength = getPathLength(pathElement, paths[i]);
        if (isFinite(currentLength) && currentLength > maxLength) {
          maxLength = currentLength;
        }
      }
      if (!maxLength || !isFinite(maxLength)) {
        samples = minSamples;
      } else {
        samples = Math.max(minSamples, Math.ceil(maxLength / sampleStep) + 1);
      }
    }

    return paths.map(function (pathData) {
      return pathToPolyline(pathElement, pathData, samples, precision);
    });
  }

  function compile(paths, options) {
    var nPaths = paths.length;
    if (!nPaths) {
      throw new Error("compile() must receive at least one path.");
    }

    var workingPaths = paths;
    if (options && options.normalize) {
      workingPaths = normalizePaths(paths, options);
    }

    var parsedPaths = workingPaths.map(parseSvgPath);
    var commands = parsedPaths[0].map(function (cmd) { return cmd[0]; });

    if (parsedPaths.some(function (path) { return path.length !== commands.length; })) {
      throw new Error("All paths must have the same number of commands.");
    }

    for (var i = 0; i < commands.length; i++) {
      if (parsedPaths.some(function (path) { return path[i][0] !== commands[i]; })) {
        throw new Error("All paths must be variations of the same sequence of commands.");
      }
    }

    var average = Array.from({ length: commands.length }, function () { return []; });
    var diffs = Array.from({ length: commands.length }, function () { return []; });

    for (var c = 0; c < commands.length; c++) {
      var nValues = parsedPaths[0][c].length - 1;
      average[c] = Array.from({ length: nValues }, function () { return 0; });
      diffs[c] = Array.from({ length: nValues }, function () { return []; });
      for (var v = 0; v < nValues; v++) {
        var sum = 0;
        for (var p = 0; p < nPaths; p++) {
          sum += parsedPaths[p][c][v + 1];
        }
        average[c][v] = sum / nPaths;
        for (var pIndex = 0; pIndex < nPaths; pIndex++) {
          diffs[c][v][pIndex] = parsedPaths[pIndex][c][v + 1] - average[c][v];
        }
      }
    }

    return {
      commands: commands,
      average: average,
      diffs: diffs,
      paths: workingPaths
    };
  }

  function morph(compiled, weights) {
    var nPaths = compiled.diffs[0][0].length;
    if (weights.length !== nPaths) {
      throw new Error("Weights must have the same length as the number of paths.");
    }

    var morphed = compiled.average.map(function (command) { return command.slice(); });
    var morphedPath = "";

    for (var c = 0; c < compiled.commands.length; c++) {
      morphedPath += compiled.commands[c];
      for (var v = 0; v < compiled.average[c].length; v++) {
        var weightedSum = compiled.diffs[c][v].reduce(function (sum, diff, p) {
          return sum + diff * weights[p];
        }, 0);
        morphed[c][v] += weightedSum;
        morphedPath += morphed[c][v] + " ";
      }
    }

    return morphedPath.trimEnd();
  }

  window.SvgPathMorph = {
    compile: compile,
    morph: morph
  };
})();
